import { useMutation } from "react-query";
import creditLimit from "../services/creditLimit";

function useSetCreditLimit() {
  return useMutation(["CreditLimit"], creditLimit);
}

export default useSetCreditLimit;
